'use client';

import type { FC, PropsWithChildren } from 'react';
import React from 'react';
import classes from './index.module.scss';
import type { CustomRenderers, Node } from './Serialize';
import { Serialize as SerializeContent } from './Serialize';
export const RichText: React.FC<{
  DefaultRender?: FC<PropsWithChildren>;
  className?: string;
  content?: Record<string, unknown>[];
  customRenderText?: FC<{
    text: string;
  }>;
  customRenderers?: CustomRenderers;
}> = ({
  DefaultRender,
  className,
  content,
  customRenderText,
  customRenderers
}) => {
  if (!content) {
    return null;
  }
  return <div className={[classes.richText, className].filter(Boolean).join(' ')} data-sentry-component="RichText" data-sentry-source-file="index.tsx">
      <SerializeContent DefaultRender={DefaultRender} content={content as Node[]} customRenderText={customRenderText} customRenderers={customRenderers} data-sentry-element="SerializeContent" data-sentry-source-file="index.tsx" />
    </div>;
};